import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';
import { IAssessmentAssignment, AssessmentStatus } from '@sondermind/utilities/models-assessments';

export const LIST_CLIENT_ASSESSMENTS_RESPONSE: IAssessmentAssignment[] = [
  {
    _id: '1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    assessmentId: 'promis-12345',
    assessmentType: ClinicalAssessmentTypes.PROMIS_ANGER,
    assignedByProviderId: 2345,
    clientId: 12345,
    clinicallyRelevantAt: new Date('2024-03-15T08:00:00Z'),
    clinicallyRelevantUntil: new Date('2024-03-22T08:00:00Z'),
    completedByProviderId: 2345,
    createdAt: new Date('2024-03-15T08:00:00Z'),
    currentQuestionIndex: 0,
    lastUpdatedAt: new Date('2024-03-15T08:00:00Z'),
    manuallySent: false,
    status: AssessmentStatus.ASSIGNED
  },
  {
    _id: '2b3c4d5e-6f7g-8h9i-0j1k-2l3m4n5o6p7q',
    assessmentId: 's2bi-23456',
    assessmentType: ClinicalAssessmentTypes.S2BI,
    assignedByProviderId: 2345,
    clientId: 12346,
    clinicallyRelevantAt: new Date('2024-03-14T08:00:00Z'),
    clinicallyRelevantUntil: new Date('2024-03-21T08:00:00Z'),
    completedByProviderId: 2345,
    createdAt: new Date('2024-03-14T08:00:00Z'),
    currentQuestionIndex: 4,
    lastUpdatedAt: new Date('2024-03-15T10:30:00Z'),
    manuallySent: true,
    status: AssessmentStatus.IN_PROGRESS
  },
  {
    _id: '3c4d5e6f-7g8h-9i0j-1k2l-3m4n5o6p7q8r',
    assessmentId: 'cssrs-55555',
    assessmentType: ClinicalAssessmentTypes.CSSRS_ADULTS,
    assignedByProviderId: 2345,
    clientId: 12347,
    clinicallyRelevantAt: new Date('2024-03-13T08:00:00Z'),
    clinicallyRelevantUntil: new Date('2024-03-20T08:00:00Z'),
    completedByProviderId: 2345,
    createdAt: new Date('2024-03-13T08:00:00Z'),
    currentQuestionIndex: 9,
    lastUpdatedAt: new Date('2024-03-14T15:45:00Z'),
    manuallySent: false,
    status: AssessmentStatus.COMPLETED
  }
];
